import Navbar from "../../component/Navbar";
import { Notamlist } from "../../component/items/NotamList";

export default function ListingData() {
  return (
    <>
      <Navbar />
      <div className="mt-20">
        {/* <Table /> */}
        <Notamlist />
      </div>
    </>
  );
}
